export const aadharConsent = Object.freeze({
  aadharConsentTextYbl: `
    I hereby declare that the details and information given above are complete and true to the best of my knowledge.`,
});

export const PAY_BALANCE_CONSTANTS = Object.freeze({
  FETCH_YBL_MIN_KYC_EXISTING_USERS: 'PayBalance/FETCH_YBL_MIN_KYC_EXISTING_USERS',
  YBL_KYC_STATIC_DATA: 'YblMinKyc/YBL_KYC_STATIC_DATA',
});



// WEBPACK FOOTER //
// client/containers/YblMinKycExistingUsers/constants.js